import {Component, ChangeDetectionStrategy} from '@angular/core';

import {Modal} from "@softline/ui-core";
import {MengenEingabeComponent} from "@softline/application";
import {KommissionierungBewegung} from "../../types/kommissionierung";
import {Palette} from "../../types/palette";
import {ArtikelHeaderComponent} from "../../components/artikel-header/artikel-header.component";
import { TranslatePipe } from '@softline/ui-core';
@Component({
    selector: 'soft-palette-aendern-dialog',
    imports: [MengenEingabeComponent, ArtikelHeaderComponent,
    TranslatePipe],
    templateUrl: './palette-aendern-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./palette-aendern-dialog.component.css']
})
export class PaletteAendernDialogComponent implements Modal<Palette | undefined> {

  public _palette!: Palette;
  public _bewegung!: KommissionierungBewegung;
  public _gewichtEditable!: boolean;

  set palette(palette: Palette) {
    this._palette = palette;
  }

  set bewegung(bewegung: KommissionierungBewegung) {
    this._bewegung = bewegung;
  }

  set gewichtEditable(editable: boolean) {
    this._gewichtEditable = editable;
  }

  close!: (result: Palette | undefined) => void;

  registerCloseHandler(handler: (result: Palette | undefined) => void): void {
    this.close = handler;
  }

  getPaletteArt(palette?: Palette) {
    return palette?.palettearten[0];
  }

  updateAnzahlPalettenLocal(menge: number) {
    if (this._palette?.palettearten[0]?.menge_offen || this._palette?.palettearten[0]?.menge_offen === 0)
      this._palette.palettearten[0].menge_offen = menge;
  }

  updateGewichtLocal(gewicht: number) {
    if (this._palette?.palettearten[0]?.gewicht_offen || this._palette?.palettearten[0]?.gewicht_offen === 0)
      this._palette.palettearten[0].gewicht_offen = gewicht;
  }
}
